export { default } from './TrendedResultsPopup';
